module.exports = __webpack_public_path__ + "static/media/image-2.af41fa0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/EOFYtrends/image-2.png
// module id = 475
// module chunks = 0